module.exports = __webpack_public_path__ + "img/Seifenblasenkanone.2ac3bce5.svg";